import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { EServiceType } from '../../../../types/reducers/publishTerms';

export const getIcon = (serviceType: IRecommendedPackageService['serviceType']): string => {
  switch (serviceType) {
    case EServiceType.Free:
      return 'offers';
    case EServiceType.Paid:
      return 'paid';
    case EServiceType.Premium:
      return 'premium';
    case EServiceType.Calltracking:
      return 'publication';
    case EServiceType.Auction:
      return 'auction';
    case EServiceType.Top3:
      return 'top3';

    default:
      return '';
  }
};
